<script>
import DatePicker from "vue2-datepicker";
import apiEndpoints from "@/services/apiEndpoints";
import manifestSet from "@/mixins/manifestSet";

export default {
  name: "manifest_info",
  props: {
    manifest: {
      type: Object,
      default: {},
    },
    manifestForDiff: {
      type: Object,
      default: {},
    },
    itemsControl: {
      type: Object,
      default: function() {
        return {};
      }
    },
    title: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    marginBoxFinal:{
      type:Number,
    },
    wastesList:{
      type: Array,
      default: () => {
        return [];
      },
    },
    errors:{
      type: Array,
      default: ()=>{
        return [];
      }
    }
  },
  components: {
    DatePicker
  },
  mixins: [manifestSet],

  data() {
    return {
      isExpandedSection: [],
      isExpandedTransshipment: [],
      isExpandedTransport: [],
      wastesAfterTreatment: [],
    }
  },
  created() {
    this.isExpandedSection = new Array(5).fill(false);
    this.isExpandedTransshipment = new Array(5).fill(false);
    this.toggleItem (3,1);
    //this.changeWaste();
    //this.wasteAfterTreatment = this.setDefaultWasteAfterTreatment();
  },
  computed: {
    getWastesList(){
      const stageOption = this.wastesList ?? [];
      return stageOption.map(obj => ({
        text: obj.id ? obj.waste_category.jw_waste_category_id + ':' + obj.name : "",
        value: obj.id ? obj.id : "",
      }));
    },
    getMixedCheckList(){
      if(this.isEdit){
        // 各々wastesListのidが一致する廃棄物からカテゴリをたどり値を取得
        let waste = this.wastesList?.filter((item) => item.id == this.manifest.waste_id)[0];
        let mixedChecks = new Array();
        if(waste?.waste_category_id_mixed_check_1) mixedChecks.push(waste.waste_category_mixed_check1);
        if(waste?.waste_category_id_mixed_check_2) mixedChecks.push(waste.waste_category_mixed_check2);
        if(waste?.waste_category_id_mixed_check_3) mixedChecks.push(waste.waste_category_mixed_check3);
        if(waste?.waste_category_id_mixed_check_4) mixedChecks.push(waste.waste_category_mixed_check4);
        if(waste?.waste_category_id_mixed_check_5) mixedChecks.push(waste.waste_category_mixed_check5);
        return mixedChecks ?? null;
      }else{
        return null;
      }
    },
    getHazardousList(){
      if(this.isEdit){
        // 各々wastesListのidが一致する廃棄物からカテゴリをたどり値を取得
        let waste = this.wastesList?.filter((item) => item.id == this.manifest.waste_id)[0];
        let hazardouses = new Array();
        if(waste?.zz_hazardous_waste_category_id_check_1) hazardouses.push(waste.zz_hazardous_waste_category_check1);
        if(waste?.zz_hazardous_waste_category_id_check_2) hazardouses.push(waste.zz_hazardous_waste_category_check2);
        if(waste?.zz_hazardous_waste_category_id_check_3) hazardouses.push(waste.zz_hazardous_waste_category_check3);
        if(waste?.zz_hazardous_waste_category_id_check_4) hazardouses.push(waste.zz_hazardous_waste_category_check4);
        if(waste?.zz_hazardous_waste_category_id_check_5) hazardouses.push(waste.zz_hazardous_waste_category_check5);
        if(waste?.zz_hazardous_waste_category_id_check_6) hazardouses.push(waste.zz_hazardous_waste_category_check6);
        return hazardouses ?? null;
      }else{
        return null;
      }
    },
    zzQuantityConfirmationUnits() {
      const stageOption = this.$store.getters['options/options_tables'].zz_quantity_confirmation_units ?? [];
      return stageOption.map(obj => ({
        text: obj.id + ':' + obj.quantity_confirmation_unit,
        value: obj.id
      }));
    },
    zzJwQuantityConfirmationCompanyTypes() {
      const stageOption = this.$store.getters['options/options_tables'].zz_jw_quantity_confirmation_company_types ?? [];
      return stageOption.map(obj => ({
        text: obj.id + ':' + obj.jw_quantity_confirmation_company_type,
        value: obj.id
      }));
    },
    zzJwPackingTypes() {
      const stageOption = this.$store.getters['options/options_tables'].zz_jw_packing_types ?? [];
      return stageOption.map(obj => ({
        text: obj.id + ':' + obj.jw_packing_type,
        value: obj.id
      }));
    },
    zzJwTransportMethods() {
      const stageOption = this.$store.getters['options/options_tables'].zz_jw_transport_methods ?? [];
      return stageOption.map(obj => ({
        text: obj.id + ':' + obj.jw_transport_method,
        value: obj.id
      }));
    },
    zzJwTreatmentMethods(){
      const stageOption = this.$store.getters['options/options_tables'].zz_jw_treatment_methods ?? [];
      return stageOption.map(obj => ({
        text: obj.id + ':' + obj.jw_treatment_method,
        value: obj.id
      }));
    },
    zzJwUnits(){
      const stageOption = this.$store.getters['options/options_tables'].zz_jw_units ?? [];
      return stageOption.map(obj => ({
        text: obj.id + ':' + obj.jw_unit,
        value: obj.id
      }));
    },
    // wasteListにdisposalSiteも持たせたのでこっちがあればOKかも
    setDefaultWasteAfterTreatment(){
      let wasteId = this.manifest.waste_id;
      let wastesList = this.wastesList;
      let waste = wastesList.filter((item) => item.id == wasteId);
      let ret = [];
      if(waste.length > 0){
        waste[0].disposal_sites.forEach(function(disposalSite){
          // 全量有価物の場合waste_category_after_treatmentが設定されていない
          if(disposalSite.disposal_site_by_waste_category.waste_category_after_treatment){
            // まだその廃棄物が存在しなければ追加
            if(ret.filter((item)=> item.value == disposalSite.disposal_site_by_waste_category.waste_category_after_treatment.id).length == 0) {
              ret.push({
                text: disposalSite.disposal_site_by_waste_category.waste_category_after_treatment.name_abbreviated,
                value: disposalSite.disposal_site_by_waste_category.waste_category_after_treatment.id
              });
            }
          }
        });
      }
      return ret;
    },
  },
  methods: {
    changeWaste(){
      if(this.isEdit){
          // 選択した廃棄物を廃棄物リストから取得
          let waste = this.wastesList?.filter((item) => item.id == this.manifest.waste_id)[0];
          if(waste == undefined){
            this.manifest.waste_category_major_classification_cd = '';
            this.manifest.waste_category_medium_classification_cd =  '';
            this.manifest.waste_category_minor_classification_cd =  '';
            this.manifest.waste_category_subminor_classification_cd =  '';
            this.manifest.waste_category_cd =  '';
            this.manifest.waste_category_name =  '';
            this.manifest.waste_name = '';
            this.manifest.is_special_waste = '0';
          }else{
            // 各モデルに情報をセット
            let major = waste?.waste_category?.jw_waste_category_id.substring(0,2) + ":" + waste?.waste_category?.major_classification;
            this.manifest.waste_category_major_classification_cd = major ?? '';
            let medium = waste?.waste_category.jw_waste_category_id.substring(2,3) + ":" + waste?.waste_category.medium_classification;
            this.manifest.waste_category_medium_classification_cd = medium ?? '';
            let minor = waste?.waste_category.jw_waste_category_id.substring(3,4) + ":" + waste?.waste_category.minor_classification;
            this.manifest.waste_category_minor_classification_cd = minor ?? '';
            let subminor = waste?.waste_category.jw_waste_category_id.substring(4,7);
            this.manifest.waste_category_subminor_classification_cd = subminor ?? '';
            let wasteCategory = waste?.waste_category.jw_waste_category_id;
            this.manifest.waste_category_cd = wasteCategory ?? '';
            let wasteCategoryName = waste?.waste_category.name_abbreviated;
            this.manifest.waste_category_name = wasteCategoryName ?? '';
            let wasteName = waste?.name;
            this.manifest.waste_name = wasteName ?? '';
            // 普通・特管の切り替え
            if(waste.waste_category?.zz_waste_category_type_id == '13'){
              this.manifest.is_special_waste = '1';
            }else{
              this.manifest.is_special_waste = '0';
            }
          }
      }
    },
    subDisposalWasteCategory(item){
      // 処理後廃棄物種類を変更かのにする場合、リストの中身は一つ固定にしてはいけない
      // どこからリストの内容を取得するかは確認のこと
      let ret = [];
      ret.push({
        // text: item.waste_category_after_treatment.name_abbreviated,
        // value: item.waste_category_after_treatment.id
        text: 'testLavel',
        value: 1, 
      });
      return ret;
    },
    fixedOptions(arr) {
      let options = [];
      for (let i = 0; i < arr.length; i++) {
        options.push({value: i , text: arr[i]});
      }
      return options;
    },
    fixedOptionsReverse(arr) {
      let options = [];
      for (let i = arr.length; i > 0; i--) {
        options.push({value: i - 1, text: arr[arr.length - i]});
      }
      return options;
    },
    optionIsReportingWastesOnIntermediateProsesses(){
      let options = [];
      options.push({value:1 , text:'当欄指定のとおり'});
      options.push({value:2 , text:'１次不要'});
      options.push({value:3 , text:'帳簿記載のとおり'});
      return options;
    },
    optionIsReportingWastesOnFinalDisposalSite(){
      let options = [];
      options.push({value:0 , text:'委託契約書記載のとおり'});
      options.push({value:1 , text:'最終処分事業場（予定）を記載する'});
      return options;
    },
    toggleItem(Section, index) {

      if (Section == 1)
        this.isExpandedSection[index - 1] = !this.isExpandedSection[index - 1];
      else if (Section == 2)
        this.isExpandedTransshipment[index - 1] = !this.isExpandedTransshipment[index - 1];
      else
        this.isExpandedTransport[index - 1] = !this.isExpandedTransport[index - 1];
    },
    isEdited(key) {
      if(!this.isEdit)
      {
        return true;
      }
      if (this.itemsControl.hasOwnProperty(key)) {
        return !this.itemsControl[key];
      }

      return true;
    },
    getMixedWaste(wasteCategoryMixedCheck) {
      return wasteCategoryMixedCheck.id + ':' + wasteCategoryMixedCheck.name_abbreviated;
    },
    getHazardousWaste(zzHazardousWasteCategory) {
      return zzHazardousWasteCategory.id + ':' + zzHazardousWasteCategory.hazardous_waste_category;
    },
    addFinalDisposalSite(item){
     let obj = {
      final_disposal_site_treatment_end_date: "",
      final_disposal_site_name: "",
      final_disposal_site_contact_to: "",
      final_disposal_site_zip: "",
      final_disposal_site_address_1: "",
      final_disposal_site_address_2: "",
      final_disposal_site_address_3: "",
      final_disposal_site_address_4: "",
      final_disposal_site_tel: "",
     }
     item['final_disposal_site_by_manifest'].push(obj);
    },
    removeFinalDisposalSite(item){
      // 最後の行削除
     // let idx = this.manifest['final_disposal_site_by_manifest'].length - 1;
     let idx = item['final_disposal_site_by_manifest'].length - 1;
     //this.manifest['final_disposal_site_by_manifest'].splice(idx,1);
     item['final_disposal_site_by_manifest'].splice(idx,1);
    },
    showRemoveFinalDisposalSite(item){
      //return this.manifest['final_disposal_site_by_manifest'].length > 0;
      // 最低一つは存在するものとする
      return item['final_disposal_site_by_manifest'].length > 1;
    },
    showRemoveWasteCategoryAfterTreatment(){
      // 最低一つは存在するものとする
      return this.manifest.wastes_after_treatment_by_manifest.length > 1;
    },
    addWasteCategoryAfterTreatment(){
      var obj = {
        manifest_id: this.manifest.id,
        waste_category_id : null,
        issue_number_2nd : null,
        final_disposal_site_by_manifest : [],
      }
      this.addFinalDisposalSite(obj);
      this.manifest.wastes_after_treatment_by_manifest.push(obj);
    },
    /**
     * 処理後廃棄物を1行減らす
     **/
    removeWasteCategoryAfterTreatment(){
      // 最後の行削除
     // let idx = this.manifest['final_disposal_site_by_manifest'].length - 1;
     let idx = this.manifest.wastes_after_treatment_by_manifest.length - 1;
     //this.manifest['final_disposal_site_by_manifest'].splice(idx,1);
     this.manifest.wastes_after_treatment_by_manifest.splice(idx,1);
    },
    checkInputFinalDiposal(){
      // 収集運搬処分・処分で工場承認が1で、有価物が「無し」「一部」の時表示するようにする
      if(this.isEdit &&
         (this.manifest.sub_disposal_vendor_valuables == 2 || this.manifest.sub_disposal_vendor_valuables == 3) &&
         (this.manifest.waste_or_service_daily_report[0].daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.disposal
        || this.manifest.waste_or_service_daily_report[0].daily_report.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.transportation_disposal)
        && this.manifest.waste_or_service_daily_report[0].treatment_approved_status == 1
      ){
        return true;
      }else{
        return false;
      }
    },
    zzValuablesInvolvedTypes() {
      return this.$store.getters['options/options_tables'].zz_valuables_involved_types ?? [];
    },
    getFixVal(isQuantity = true){
      if(this.isEdit){
        // 数量確定者を見て、それによりどの数量を確定数量とするか判断する
        // 単位はコードから名称にすること
        switch(this.manifest.quantity_confirmation_company_type_cd){
          case this.$constant.zzJwQuantityConfirmationCompanyTypes.none:
            // 空
            return "";
          case this.$constant.zzJwQuantityConfirmationCompanyTypes.discharger:
            // 排出量
            return (isQuantity)?this.manifest.amount_of_emissions:this.manifest.quantity_confirmation_unit_cd;
          case this.$constant.zzJwQuantityConfirmationCompanyTypes.disposal:
            // 受入量
            return (isQuantity)?this.manifest.sub_disposal_vendor_disposal_amount:this.manifest.sub_disposal_vendor_disposal_unit;
          case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans1st:
            // 運搬量
            return (isQuantity)?this.manifest.sub_transport_vendor_1_transport_amount:this.manifest.sub_transport_vendor_1_transport_unit;
          case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans2nd:
            return (isQuantity)?this.manifest.sub_transport_vendor_2_transport_amount:this.manifest.sub_transport_vendor_2_transport_unit;
          case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans3rd:
            return (isQuantity)?this.manifest.sub_transport_vendor_3_transport_amount:this.manifest.sub_transport_vendor_3_transport_unit;
          case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans4th:
            return (isQuantity)?this.manifest.sub_transport_vendor_4_transport_amount:this.manifest.sub_transport_vendor_4_transport_unit;
          case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans5th:
            return (isQuantity)?this.manifest.sub_transport_vendor_5_transport_amount:this.manifest.sub_transport_vendor_5_transport_unit;
        }
      }else{
        //JWNの場合はそれ用の値を持っているはずなのでそこから取得したい、
        return (isQuantity)?this.manifest.quantity_confirmation:this.manifest.quantity_unit_confirmation_zz_jw_unit_id;
      }
      return "";
    },
    // 確定数量の取得
    getFixQuantity(){
      let isQuantity = true;
      return this.getFixVal(isQuantity);
    },
    getFixUnit(){
      let isQuantity = false;
      return this.getFixVal(isQuantity);
    },
    checkDifferFDS(item_fdsbm){
      // item_fdsbm (最終処分場)がマニフェスト側に存在するかを確認する
      let isExists = false;
      this.manifestForDiff.wastes_after_treatment_by_manifest?.forEach(function(item){
        item.final_disposal_site_by_manifest.map(function(obj){
          if(
            item_fdsbm.final_disposal_site_treatment_end_date == obj.final_disposal_site_treatment_end_date &&
            item_fdsbm.final_disposal_site_name == obj.final_disposal_site_name &&
            item_fdsbm.final_disposal_site_zip == obj.final_disposal_site_zip &&
            item_fdsbm.final_disposal_site_address_1 == obj.final_disposal_site_address_1 &&
            item_fdsbm.final_disposal_site_address_2 == obj.final_disposal_site_address_2 &&
            item_fdsbm.final_disposal_site_address_3 == obj.final_disposal_site_address_3 &&
            item_fdsbm.final_disposal_site_address_4 == obj.final_disposal_site_address_4 &&
            item_fdsbm.final_disposal_site_tel == obj.final_disposal_site_tel
          ){
            isExists = true;
          }
        });
      });

      if(isExists){
        return '';
      }else{
        return 'bg-warning';
      }
    },
    // wasteListにdisposalSiteも持たせたのでこっちがあればOKかも
  //   setDefaultWasteAfterTreatment(){
  //     let wasteId = this.manifest.waste_id;
  //     let wasteList = this.wasteList;
  //     let waste = wasteList.filter((item) => item.id == wasteId);
  //     let ret = [];
  //     waste.forEach(function(disposalSite){
  //       ret.push({
  //         text: disposalSite.disposalSiteByWasteCategory.wasteCategoryAfterTreatment.name_abbreviated,
  //         value: disposalSite.disposalSiteByWasteCategory.wasteCategoryAfterTreatment.id
  //       });
  //     });
  //     return ret;
  //   },
  //   async subDisposalWasteCategory2(item){
  //     // 処理後廃棄物のリストは廃棄物に紐づいた処分場が持つ処理後廃棄物の一覧を表示する
  //     let waste = this.manifest.waste_id;
  //     let wastes = [];
  //     var ret = [];
  //     let url = apiEndpoints.wastes_detail(waste);
  //     const sendApiProject = await this.$http.get(url, {});
  //     const { status, data } = sendApiProject;
  //     if (status) {
  //        wastes = data.result;
  //     }
  //     wastes.disposal_sites.forEach(function(disposalSite){
  //       ret.push({
  //         text: disposalSite.disposal_site_by_waste_category.waste_category_after_treatment.name_abbreviated,
  //         value: disposalSite.disposal_site_by_waste_category.waste_category_after_treatment.id,
  //       });
  //     });
  //     return ret;
  //   },
  }
}
</script>

<template>
  <div class="manifest">
    <div>
      <div :class="(isEdit?'bg-info ':'bg-success ') +'ps-1 title mt-3 fw-bold font-size-16 text-white'">
        {{ title }}
      </div>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.date_of_issue, manifestForDiff.date_of_issue) && manifest.manifest_type_cd != 1}">
            <label for="" class="custom-lbl-box">引渡日</label>
            <ValidationProvider
              rules="required"
              :custom-messages="{ required: '交付年月日は必須項目です' }"
              v-slot="{ errors, classes }"
            >
              <div :class="classes" class="input-control">
                <date-picker
                  v-model="manifest.date_of_issue"
                  :disabled="isEdited('date_of_issue')"
                  lang="ja"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  value-type="format"
                  type="date"
                ></date-picker>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.number_of_issue, manifestForDiff.number_of_issue) && manifest.manifest_type_cd != 1}">
            <label for="" class="custom-lbl-box">交付番号</label>
            <ValidationProvider
              rules="required"
              :custom-messages="{ required: '交付番号は必須項目です' }"
              v-slot="{ errors, classes }"
            >
              <div :class="classes" class="input-control">
                <b-form-input 
                type="text" 
                v-model="manifest.number_of_issue" 
                maxlength="11" 
                :disabled="isEdited('number_of_issue')" 
                />
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
          <div v-if="errors[`number_of_issue`] && this.isEdit" class="error-message">{{ errors[`number_of_issue`][0] }}</div>
        </b-col>
      </b-row>
    </div>
    <div>
      <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title mt-3  fw-bold font-size-16 text-white'">排出事業者情報</div>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_registration_number, manifestForDiff.discharger_registration_number)
           && manifest.manifest_type_cd != 1}">
            <label for="">加入者番号</label>
            <b-form-input maxlength="7" type="text" v-model="manifest.discharger_registration_number" :disabled="isEdited('discharger_registration_number')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_name, manifestForDiff.discharger_name)
           && manifest.manifest_type_cd != 1}">
            <label for="">事業者名</label>
            <b-form-input maxlength="260" type="text" v-model="manifest.discharger_name" :disabled="isEdited('discharger_name')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_tel, manifestForDiff.discharger_tel)
           && manifest.manifest_type_cd != 1}">
            <label for="">電話番号</label>
            <b-form-input maxlength="15" type="text" v-model="manifest.discharger_tel" :disabled="isEdited('discharger_tel')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_zip, manifestForDiff.discharger_zip)
           && manifest.manifest_type_cd != 1}">
            <label for="">郵便番号</label>
            <b-form-input maxlength="8" type="text" v-model="manifest.discharger_zip" :disabled="isEdited('discharger_zip')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_address_1, manifestForDiff.discharger_address_1)
           && manifest.manifest_type_cd != 1}">
            <label for="">都道府県</label>
            <b-form-input type="text" maxlength="8" v-model="manifest.discharger_address_1" :disabled="isEdited('discharger_address_1')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_address_2, manifestForDiff.discharger_address_2)
           && manifest.manifest_type_cd != 1}">
            <label for="">市区</label>
            <b-form-input type="text" maxlength="40" v-model="manifest.discharger_address_2" :disabled="isEdited('discharger_address_2')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_address_3, manifestForDiff.discharger_address_3)
           && manifest.manifest_type_cd != 1}">
            <label for="">町村</label>
            <b-form-input type="text" maxlength="80" v-model="manifest.discharger_address_3" :disabled="isEdited('discharger_address_3')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_address_4, manifestForDiff.discharger_address_4)
           && manifest.manifest_type_cd != 1}">
            <label for="">番地建物名</label>
            <b-form-input type="text" maxlength="100" v-model="manifest.discharger_address_4" :disabled="isEdited('discharger_address_4')"/>
          </div>
        </b-col>
      </b-row>
    </div>
    <div>
      <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title mt-3  fw-bold font-size-16 text-white'">排出事業場情報</div>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_site_name, manifestForDiff.discharger_site_name)
           && manifest.manifest_type_cd != 1}">
            <label for="">事業場名</label>
            <b-form-input type="text" maxlength="120" v-model="manifest.discharger_site_name" :disabled="isEdited('discharger_site_name')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_site_tel, manifestForDiff.discharger_site_tel)
           && manifest.manifest_type_cd != 1}">
            <label for="">電話番号</label>
            <b-form-input type="text" maxlength="15" v-model="manifest.discharger_site_tel" :disabled="isEdited('discharger_site_tel')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_site_zip, manifestForDiff.discharger_site_zip)
           && manifest.manifest_type_cd != 1}">
            <label for="">郵便番号</label>
            <b-form-input type="text" maxlength="8" v-model="manifest.discharger_site_zip" :disabled="isEdited('discharger_site_zip')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_site_address_1, manifestForDiff.discharger_site_address_1)
           && manifest.manifest_type_cd != 1}">
            <label for="">都道府県</label>
            <b-form-input type="text" maxlength="8" v-model="manifest.discharger_site_address_1" :disabled="isEdited('discharger_site_address_1')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_site_address_2, manifestForDiff.discharger_site_address_2)
           && manifest.manifest_type_cd != 1}">
            <label for="">市区</label>
            <b-form-input type="text" maxlength="40" v-model="manifest.discharger_site_address_2" :disabled="isEdited('discharger_site_address_2')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_site_address_3, manifestForDiff.discharger_site_address_3)
           && manifest.manifest_type_cd != 1}">
            <label for="">町村</label>
            <b-form-input type="text" maxlength="80" v-model="manifest.discharger_site_address_3" :disabled="isEdited('discharger_site_address_3')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_site_address_4, manifestForDiff.discharger_site_address_4)
           && manifest.manifest_type_cd != 1}">
            <label for="">番地建物名</label>
            <b-form-input type="text" maxlength="100" v-model="manifest.discharger_site_address_4" :disabled="isEdited('discharger_site_address_4')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_site_reporting_user_name, manifestForDiff.discharger_site_reporting_user_name)
           && manifest.manifest_type_cd != 1}">
            <label for="">登録担当者</label>
            <b-form-input type="text" maxlength="24" v-model="manifest.discharger_site_reporting_user_name" :disabled="isEdited('discharger_site_reporting_user_name')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.discharger_site_handover_person_in_charge, manifestForDiff.discharger_site_handover_person_in_charge)
           && manifest.manifest_type_cd != 1}">
            <label for="">引渡担当者</label>
            <b-form-input type="text" maxlength="24" v-model="manifest.discharger_site_handover_person_in_charge" :disabled="isEdited('discharger_site_handover_person_in_charge')"/>
          </div>
        </b-col>
      </b-row>
    </div>
    <div>
      <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title mt-3  fw-bold font-size-16 text-white'">廃棄物情報</div>

      <b-row class="mt-2">
        <b-col cols="12">
          <div class="custom-input gap-2">
            <label for="">廃棄物</label>
            <b-form-select 
             class="form-select" 
             :disabled="!isEdit"
             :options="this.getWastesList"
             v-model="manifest.waste_id"
             @change="changeWaste"
             />
             <div v-if="errors[`waste_id`] && this.isEdit" class="error-message">{{ errors[`waste_id`][0] }}</div>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.waste_category_major_classification_cd, manifestForDiff.waste_category_major_classification_cd)
           && manifest.manifest_type_cd != 1}">
            <label for="">大分類</label>
            <b-form-input type="text" maxlength="102" readonly="readonly" v-model="manifest.waste_category_major_classification_cd":disabled="isEdited('waste_category_major_classification_cd')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.waste_category_medium_classification_cd, manifestForDiff.waste_category_medium_classification_cd)
           && manifest.manifest_type_cd != 1}">
            <label for="">中分類</label>
            <b-form-input type="text" maxlength="101" readonly="readonly" v-model="manifest.waste_category_medium_classification_cd" :disabled="isEdited('waste_category_medium_classification_cd')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.waste_category_minor_classification_cd, manifestForDiff.waste_category_minor_classification_cd)
           && manifest.manifest_type_cd != 1}">
            <label for="">小分類</label>
            <b-form-input type="text" maxlength="101" readonly="readonly" v-model="manifest.waste_category_minor_classification_cd" :disabled="isEdited('waste_category_minor_classification_cd')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.waste_category_subminor_classification_cd, manifestForDiff.waste_category_subminor_classification_cd)
           && manifest.manifest_type_cd != 1}">
            <label for="">細分類</label>
            <b-form-input type="text" maxlength="103" readonly="readonly" v-model="manifest.waste_category_subminor_classification_cd" :disabled="isEdited('waste_category_subminor_classification_cd')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.waste_category_cd, manifestForDiff.waste_category_cd)
           && manifest.manifest_type_cd != 1}">
            <label for="">種類コード</label>
            <b-form-input type="text" readonly="readonly" v-model="manifest.waste_category_cd" :disabled="isEdited('jw_waste_category_id')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" >
            <label for="">種類</label>
            <b-form-input type="text" v-if="manifest.waste_category"
                          readonly="readonly"
                          v-model="manifest.waste_category_name"
                          :disabled="isEdited('waste_category_name')"/>
            <b-form-input type="text" v-else :disabled="isEdited('waste_category_name')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.waste_name, manifestForDiff.waste_name)
           && manifest.manifest_type_cd != 1}">
            <label for="">廃棄物の名称</label>
            <b-form-input type="text" maxlength="60" readonly="readonly" v-model="manifest.waste_name" :disabled="isEdited('waste_name')"></b-form-input>
          </div>
        </b-col>
      </b-row>
      <div class="mt-2">
        <div class="lbl-custom">チェック用廃棄物種類</div>
            <ul class="ml-custom box-waste-custom" v-if="getMixedCheckList">
              <li 
              v-for="(item,index) in getMixedCheckList"
              >{{ getMixedWaste(item)}}
            </li>
            </ul>
            <div v-else class="box-waste-custom"></div>
      </div>
      <div class="mt-2 mb-2">
        <div class="lbl-custom">有害物質等</div>
          <ul class="ml-custom box-waste1-custom" v-if="getHazardousList">
            <li
              v-for="(hazardousWaste,index) in getHazardousList"
              :key="'hazardous_waste'+index"
            >
              {{ hazardousWaste.id + ':' + hazardousWaste.hazardous_waste_category }}
            </li>
          </ul>
          <div v-else class="box-waste1-custom"></div>
      </div>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2 custom-minH" v-if="isEdit">
            <label class="lbl-custom">普通・特管</label>
            <b-form-radio-group
              class="d-flex align-items-center gap-2 w-100 h-100"
              :disabled="isEdited('is_special_waste')"
              v-model="manifest.is_special_waste"
              :options="fixedOptions(['普通', '特管'])"
            ></b-form-radio-group>
          </div>
          <div class="custom-minH" v-else></div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.amount_of_emissions, manifestForDiff.amount_of_emissions)
           && manifest.manifest_type_cd != 1}">
            <label for="">排出量</label>
            <b-form-input type="number" v-model="manifest.amount_of_emissions" :disabled="isEdited('amount_of_emissions')" />
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.quantity_confirmation_unit_cd, manifestForDiff.quantity_confirmation_unit_cd)
           && manifest.manifest_type_cd != 1}">
            <label for="">単位</label>
            <b-form-select class=" form-select" v-model="manifest.quantity_confirmation_unit_cd" :options="zzJwUnits" :disabled="isEdited('quantity_confirmation_unit_cd')"></b-form-select>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.quantity_confirmation_company_type_cd, manifestForDiff.quantity_confirmation_company_type_cd)
           && manifest.manifest_type_cd != 1}">
            <label for="">数量確定者</label>
            <b-form-select class="form-select" v-model="manifest.quantity_confirmation_company_type_cd" :options="zzJwQuantityConfirmationCompanyTypes" :disabled="isEdited('quantity_confirmation_company_type_cd')"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2">
            <label for="">確定数量</label>
            <b-form-input type="text" :value=getFixQuantity() :disabled="true"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2">
            <label for="">確定数量単位</label>
            <b-form-select class=" form-select" :value=getFixUnit() :options="zzJwUnits" :disabled="true"></b-form-select>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.packing_type_cd, manifestForDiff.packing_type_cd)
           && manifest.manifest_type_cd != 1}">
            <label for="">荷姿</label>
            <b-form-select class="form-select" v-model="manifest.packing_type_cd" :options="zzJwPackingTypes" :disabled="isEdited('packing_type_cd')"/>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.packing_quantity, manifestForDiff.packing_quantity)
           && manifest.manifest_type_cd != 1}">
            <label for="">荷姿数量</label>
            <b-form-input type="text" maxlength="5" v-model="manifest.packing_quantity" :disabled="isEdited('packing_quantity')"/>
          </div>
        </b-col>
      </b-row>
    </div>
    <div :class="{'custom-jw':!isEdit}">
      <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title mt-3 fw-bold font-size-16 text-white'">運搬予定情報</div>
      <div v-for="index in 5" :key="index">
        <div class="ms-2">
          <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title mt-2 fw-bold font-size-16 text-white'"
               @click="toggleItem(1,index)" v-b-toggle="'collap-section'+index">
            区間{{ index }}
            <span :class="{'rotate': isExpandedSection[index-1]}" class="icon">▼</span>
          </div>
          <b-collapse :id="'collap-section'+index" v-model="isExpandedSection[index-1]">
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">事業者名</label>
                  <b-form-input type="text" maxlength="260" v-model="manifest['transport_vendor_'+index+'_name']" :disabled="isEdited('transport_vendor_'+index+'_name')"/>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">連絡先</label>
                  <b-form-input maxlength="15" type="text" v-model="manifest['transport_vendor_'+index+'_contact_to']"
                                :disabled="isEdited('transport_vendor_'+index+'_contact_to')"/>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">郵便番号</label>
                  <b-form-input type="text" maxlength="8" v-model="manifest['transport_vendor_'+index+'_zip']" :disabled="isEdited('transport_vendor_'+index+'_zip')"/>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">都道府県</label>
                  <b-form-input type="text" maxlength="8" v-model="manifest['transport_vendor_'+index+'_address_1']"
                                :disabled="isEdited('transport_vendor_'+index+'_address_1')"/>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">市区</label>
                  <b-form-input type="text" maxlength="40" v-model="manifest['transport_vendor_'+index+'_address_2']"
                                :disabled="isEdited('transport_vendor_'+index+'_address_2')"/>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">町村</label>
                  <b-form-input type="text" maxlength="80" v-model="manifest['transport_vendor_'+index+'_address_3']"
                                :disabled="isEdited('transport_vendor_'+index+'_address_3')"></b-form-input>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">番地建物名</label>
                  <b-form-input type="text" maxlength="100" v-model="manifest['transport_vendor_'+index+'_address_4']"
                                :disabled="isEdited('transport_vendor_'+index+'_address_4')"></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">運搬方法</label>
                  <b-form-select class="form-select" v-model="manifest['transport_vendor_'+index+'_transport_method']" :options="zzJwTransportMethods"
                                :disabled="isEdited('transport_vendor_'+index+'_transport_method')"/>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">運搬担当者</label>
                  <b-form-input type="text" maxlength="24" v-model="manifest['transport_vendor_'+index+'_transport_person_in_charge']"
                                :disabled="isEdited('transport_vendor_'+index+'_transport_person_in_charge')"/>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">車両番号</label>
                  <b-form-input type="text" maxlength="30" v-model="manifest['transport_vendor_'+index+'_car_number']"
                                :disabled="isEdited('transport_vendor_'+index+'_car_number')"/>
                </div>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <div class="ms-2">
          <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title mt-2 fw-bold font-size-16 text-white'"
               @click="toggleItem(2,index)" v-b-toggle="'collap-transshipment'+index">
            積替保管場所/運搬先{{ index }}
            <span :class="{'rotate': isExpandedTransshipment[index-1]}" class="icon">▼</span>
          </div>
          <b-collapse :id="'collap-transshipment'+index" v-model="isExpandedTransshipment[index-1]">
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">事業場番号</label>
                  <b-form-input type="text" maxlength="3" v-model="manifest['transport_and_hold_vendor_site_'+index+'_number']"
                                :disabled="isEdited('transport_and_hold_vendor_site_'+index+'_number')"/>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">事業場名</label>
                  <b-form-input type="text" maxlength="120" v-model="manifest['transport_and_hold_vendor_site_'+index+'_name']"
                                :disabled="isEdited('transport_and_hold_vendor_site_'+index+'_name')"/>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">連絡先</label>
                  <b-form-input type="text" maxlength="15" v-model="manifest['transport_and_hold_vendor_site_'+index+'_contact_to']"
                                :disabled="isEdited('transport_and_hold_vendor_site_'+index+'_contact_to')"/>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">郵便番号</label>
                  <b-form-input type="text" maxlength="8" v-model="manifest['transport_and_hold_vendor_site_'+index+'_zip']"
                                :disabled="isEdited('transport_and_hold_vendor_site_'+index+'_zip')"/>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">都道府県</label>
                  <b-form-input type="text" maxlength="8" v-model="manifest['transport_and_hold_vendor_site_'+index+'_address_1']"
                                :disabled="isEdited('transport_and_hold_vendor_site_'+index+'_address_1')"/>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">市区</label>
                  <b-form-input type="text" maxlength="40" v-model="manifest['transport_and_hold_vendor_site_'+index+'_address_2']"
                                :disabled="isEdited('transport_and_hold_vendor_site_'+index+'_address_2')"/>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">町村</label>
                  <b-form-input type="text" maxlength="80" v-model="manifest['transport_and_hold_vendor_site_'+index+'_address_3']"
                                :disabled="isEdited('transport_and_hold_vendor_site_'+index+'_address_3')"/>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="custom-input gap-2">
                  <label for="">番地建物名</label>
                  <b-form-input type="text" maxlength="100" v-model="manifest['transport_and_hold_vendor_site_'+index+'_address_4']"
                                :disabled="isEdited('transport_and_hold_vendor_site_'+index+'_address_4')"/>
                </div>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
      </div>
    </div>
    <div :class="{'custom-jw':!isEdit}">
      <div :class="(isEdit ? 'bg-info ' : 'bg-success ') +'ps-1 title mt-3 fw-bold font-size-16 text-white'">処分予定情報
      </div>
      <div class="ms-2 mt-2">
        <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title fw-bold font-size-16 text-white'">事業者情報</div>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">加入番号</label>
              <b-form-input type="text" maxlength="7" v-model="manifest.disposal_vendor_registration_number" :disabled="isEdited('disposal_vendor_registration_number')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">事業者名</label>
              <b-form-input type="text" maxlength="260" v-model="manifest.disposal_vendor_name" :disabled="isEdited('disposal_vendor_name')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">電話番号</label>
              <b-form-input type="text" maxlength="15" v-model="manifest.disposal_vendor_tel" :disabled="isEdited('disposal_vendor_tel')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">郵便番号</label>
              <b-form-input type="text" maxlength="8" v-model="manifest.disposal_vendor_zip" :disabled="isEdited('disposal_vendor_zip')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">都道府県</label>
              <b-form-input type="text" maxlength="8" v-model="manifest.disposal_vendor_address_1" :disabled="isEdited('disposal_vendor_address_1')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">市区</label>
              <b-form-input type="text" maxlength="40" v-model="manifest.disposal_vendor_address_2" :disabled="isEdited('disposal_vendor_address_2')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">町村</label>
              <b-form-input type="text" maxlength="80" v-model="manifest.disposal_vendor_address_3" :disabled="isEdited('disposal_vendor_address_3')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">番地建物名</label>
              <b-form-input type="text" maxlength="100" v-model="manifest.disposal_vendor_address_4" :disabled="isEdited('disposal_vendor_address_4')"/>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="ms-2 mt-2">
        <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title fw-bold font-size-16 text-white'">事業場情報</div>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">事業場番号</label>
              <b-form-input type="text" maxlength="3" v-model="manifest.disposal_vendor_site_registration_number"
                            :disabled="isEdited('disposal_vendor_site_registration_number')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">事業場名</label>
              <b-form-input type="text" maxlength="120" v-model="manifest.disposal_vendor_site_name" :disabled="isEdited('disposal_vendor_site_name')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">電話番号</label>
              <b-form-input type="text" maxlength="15" v-model="manifest.disposal_vendor_site_tel" :disabled="isEdited('disposal_vendor_site_tel')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">郵便番号</label>
              <b-form-input type="text" maxlength="8" v-model="manifest.disposal_vendor_site_zip" :disabled="isEdited('disposal_vendor_site_zip')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">都道府県</label>
              <b-form-input type="text" maxlength="8" v-model="manifest.disposal_vendor_site_address_1" :disabled="isEdited('disposal_vendor_site_address_1')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">市区</label>
              <b-form-input type="text" maxlength="40" v-model="manifest.disposal_vendor_site_address_2" :disabled="isEdited('disposal_vendor_site_address_2')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">町村</label>
              <b-form-input type="text" maxlength="80" v-model="manifest.disposal_vendor_site_address_3" :disabled="isEdited('disposal_vendor_site_address_3')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2">
              <label for="">番地建物名</label>
              <b-form-input type="text" maxlength="100" v-model="manifest.disposal_vendor_site_address_4" :disabled="isEdited('disposal_vendor_site_address_4')"/>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div>
      <div class="ms-2 mt-2">
        <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title fw-bold font-size-16 text-white'">処分付帯情報</div>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.disposal_vendor_site_treatment_method, manifestForDiff.disposal_vendor_site_treatment_method)
              && manifest.manifest_type_cd != 1}">
              <label for="">処分方法</label>
              <b-form-select
              class="form-select"
              v-model="manifest.disposal_vendor_site_treatment_method"
              :options="zzJwTreatmentMethods" :disabled="isEdited('disposal_vendor_site_treatment_method')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <div class="custom-radio-group gap-2" :class="{'bg-warning':isDiff(manifest.is_reporting_wastes_on_intermediate_prosesses, manifestForDiff.is_reporting_wastes_on_intermediate_prosesses)
              && manifest.manifest_type_cd != 1}">
              <label class="label-group">中間処理産業廃棄物</label>
              <b-form-radio-group
                class="d-flex align-items-center gap-2 w-100 h-100"
                v-model="manifest.is_reporting_wastes_on_intermediate_prosesses"
                :disabled="isEdited('is_reporting_wastes_on_intermediate_prosesses')"
                :options="optionIsReportingWastesOnIntermediateProsesses()"
              ></b-form-radio-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.remarks_of_wastes_on_intermediate_prosesses, manifestForDiff.remarks_of_wastes_on_intermediate_prosesses)
              && manifest.manifest_type_cd != 1}">
              <label for="">備考</label>
              <b-form-input type="text" maxlength="256" v-model="manifest.remarks_of_wastes_on_intermediate_prosesses"
                            :disabled="isEdited('remarks_of_wastes_on_intermediate_prosesses')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <div class="custom-radio-group gap-2" :class="{'bg-warning':isDiff(manifest.is_reporting_wastes_on_final_disposal_site, manifestForDiff.is_reporting_wastes_on_final_disposal_site)
              && manifest.manifest_type_cd != 1}">
              <label class="label-group">最終処分の場所</label>
              <b-form-radio-group
                class="d-flex align-items-center gap-2 w-100 h-100"
                :disabled="isEdited('is_reporting_wastes_on_final_disposal_site')"
                v-model="manifest.is_reporting_wastes_on_final_disposal_site"
                :options="optionIsReportingWastesOnFinalDisposalSite()"
              ></b-form-radio-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.final_disposal_vendor_site_name, manifestForDiff.final_disposal_vendor_site_name)
              && manifest.manifest_type_cd != 1}">
              <label for="">処分場所</label>
              <b-form-input type="text" maxlength="120" v-model="manifest.final_disposal_vendor_site_name" :disabled="isEdited('final_disposal_vendor_site_name')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.final_disposal_vendor_zip, manifestForDiff.final_disposal_vendor_zip)
              && manifest.manifest_type_cd != 1}">
              <label for="">郵便番号</label>
              <b-form-input type="text" maxlength="8" v-model="manifest.final_disposal_vendor_zip" :disabled="isEdited('final_disposal_vendor_zip')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.final_disposal_vendor_address_1, manifestForDiff.final_disposal_vendor_address_1)
              && manifest.manifest_type_cd != 1}">
              <label for="">都道府県</label>
              <b-form-input type="text" maxlength="8" v-model="manifest.final_disposal_vendor_address_1" :disabled="isEdited('final_disposal_vendor_address_1')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.final_disposal_vendor_address_2, manifestForDiff.final_disposal_vendor_address_2)
              && manifest.manifest_type_cd != 1}">
              <label for="">市区</label>
              <b-form-input type="text" maxlength="40" v-model="manifest.final_disposal_vendor_address_2" :disabled="isEdited('final_disposal_vendor_address_2')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.final_disposal_vendor_address_3, manifestForDiff.final_disposal_vendor_address_3)
              && manifest.manifest_type_cd != 1}">
              <label for="">町村</label>
              <b-form-input type="text" maxlength="80" v-model="manifest.final_disposal_vendor_address_3" :disabled="isEdited('final_disposal_vendor_address_3')"/>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.final_disposal_vendor_address_4, manifestForDiff.final_disposal_vendor_address_4)
              && manifest.manifest_type_cd != 1}">
              <label for="">番地建物名</label>
              <b-form-input type="text" maxlength="100" v-model="manifest.final_disposal_vendor_address_4" :disabled="isEdited('final_disposal_vendor_address_4')"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.final_disposal_vendor_tel, manifestForDiff.final_disposal_vendor_tel)
              && manifest.manifest_type_cd != 1}">
              <label for="">電話番号</label>
              <b-form-input type="text" maxlength="15" v-model="manifest.final_disposal_vendor_tel" :disabled="isEdited('final_disposal_vendor_tel')"/>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="ms-2">
        <div :class="(isEdit?'bg-info ':'bg-success ') + 'ps-1 title mt-2 fw-bold font-size-16 text-white'">備考情報</div>
        <b-row class="mt-2" v-for="index in 5" :key="index" :id="index">
          <b-col cols="12">
            <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['remarks_' + index],manifestForDiff['remarks_' + index])
             && manifest.manifest_type_cd != 1}">
              <label for="" class="text-center">{{ index }}</label>
              <b-form-input type="text" maxlength="50" v-model="manifest['remarks_'+ index]" :disabled="isEdited('remarks_'+ index)"/>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="mt-3">
        <div :class="(isEdit ? 'bg-info ' :'bg-success ') + 'ps-1 title fw-bold font-size-16 text-white'">実績情報</div>
        <div class="ms-2">
          <div>
            <div :class="(isEdit ? 'bg-info ' :'bg-success ') + 'ps-1 title mt-2 fw-bold font-size-16 text-white'">
              運搬の受託
            </div>
            <div v-for="index in 5" :key="index">
              <div class="ms-2">
                <div :class="(isEdit ? 'bg-info ' : 'bg-success ') + 'ps-1 title mt-2 fw-bold font-size-16 text-white'"
                     @click="toggleItem(3,index)" v-b-toggle="'collap-transport'+index">
                  区間{{ index }}
                  <span :class="{'rotate': isExpandedTransport[index-1]}" class="icon">▼</span>
                </div>
                <b-collapse :id="'collap-transport'+index" v-model="isExpandedTransport[index-1]">
                  <b-row class="mt-2">
                    <b-col cols="6">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_name'],
                        manifestForDiff['sub_transport_vendor_' + index + '_name']) && manifest.manifest_type_cd != 1}">
                        <label for="">事業者名</label>
                        <b-form-input type="text" maxlength="260" v-model="manifest['sub_transport_vendor_'+index+'_name']"
                                      :disabled="isEdited('sub_transport_vendor_'+index+'_name')"/>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="6">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_end_date'],
                        manifestForDiff['sub_transport_vendor_' + index + '_end_date']) && manifest.manifest_type_cd != 1}">
                        <label for="">運搬終了日</label>
                        <date-picker
                          v-model="manifest['sub_transport_vendor_'+index+'_end_date']"
                          :disabled="isEdited('sub_transport_vendor_'+index+'_end_date')"
                          lang="ja"
                          placeholder="YYYY-MM-DD"
                          format="YYYY-MM-DD"
                          value-type="format"
                          type="date"
                        ></date-picker>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_car_number'],
                        manifestForDiff['sub_transport_vendor_' + index + '_car_number']) && manifest.manifest_type_cd != 1}">
                        <label for="">車両番号</label>
                        <b-form-input type="text" maxlength="30" v-model="manifest['sub_transport_vendor_'+index+'_car_number']"
                                      :disabled="isEdited('sub_transport_vendor_'+index+'_car_number')"/>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="6">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_transport_amount'],
                        manifestForDiff['sub_transport_vendor_' + index + '_transport_amount']) && manifest.manifest_type_cd != 1}">
                        <label for="">運搬量</label>
                        <b-form-input type="number"
                                      v-model="manifest['sub_transport_vendor_'+index+'_transport_amount']"
                                      maxlength="8"
                                      :disabled="isEdited('sub_transport_vendor_'+index+'_transport_amount')"/>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_transport_unit'],
                        manifestForDiff['sub_transport_vendor_' + index + '_transport_unit']) && manifest.manifest_type_cd != 1}">
                        <label for="">運搬量単位</label>
                        <b-form-select class="form-select" v-model="manifest['sub_transport_vendor_'+index+'_transport_unit']" :options="zzJwUnits"
                                      :disabled="isEdited('sub_transport_vendor_'+index+'_transport_unit')"/>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="6">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_valuables_amount'],
                        manifestForDiff['sub_transport_vendor_' + index + '_valuables_amount']) && manifest.manifest_type_cd != 1}">
                        <label for="">有価物拾集量</label>
                        <b-form-input type="number"
                                      maxlength="8"
                                      v-model="manifest['sub_transport_vendor_'+index+'_valuables_amount']"
                                      :disabled="isEdited('sub_transport_vendor_'+index+'_valuables_amount')"/>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_valuables_unit'],
                        manifestForDiff['sub_transport_vendor_' + index + '_valuables_unit']) && manifest.manifest_type_cd != 1}">
                        <label for="">有価物拾集量単位</label>
                        <b-form-select
                          class="form-select"
                          v-model="manifest['sub_transport_vendor_'+index+'_valuables_unit']"
                          :options="zzJwUnits"
                          :disabled="isEdited('sub_transport_vendor_'+index+'_valuables_unit')"
                        />
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="6">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_reporting_user_name'],
                        manifestForDiff['sub_transport_vendor_' + index + '_reporting_user_name']) && manifest.manifest_type_cd != 1}">
                        <label for="">報告担当者</label>
                        <b-form-input type="text" maxlength="24"
                                      v-model="manifest['sub_transport_vendor_'+index+'_reporting_user_name']"
                                      :disabled="isEdited('sub_transport_vendor_'+index+'_reporting_user_name')"/>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_delivery_person_in_charge'],
                        manifestForDiff['sub_transport_vendor_' + index + '_delivery_person_in_charge']) && manifest.manifest_type_cd != 1}">
                        <label for="">運搬担当者</label>
                        <b-form-input type="text" maxlength="24"
                                      v-model="manifest['sub_transport_vendor_'+index+'_delivery_person_in_charge']"
                                      :disabled="isEdited('sub_transport_vendor_'+index+'_delivery_person_in_charge')"/>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="12">
                      <div class="custom-input gap-2" :class="{'bg-warning': isDiff(manifest['sub_transport_vendor_' + index + '_remarks'],
                        manifestForDiff['sub_transport_vendor_' + index + '_remarks']) && manifest.manifest_type_cd != 1}">
                        <label for="">備考</label>
                        <b-form-input type="text" maxlength="256" v-model="manifest['sub_transport_vendor_'+index+'_remarks']"
                                      :disabled="isEdited('sub_transport_vendor_'+index+'_remarks')"/>
                      </div>
                    </b-col>
                  </b-row>
                </b-collapse>
              </div>
            </div>
          </div>
          <div>
            <div class="mt-2">
              <div :class="(isEdit ? 'bg-info ' : 'bg-success ') + 'ps-1 title  fw-bold font-size-16 text-white'">
                処分の受託
              </div>
              <b-row class="mt-2">
                <b-col cols="6">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_name, manifestForDiff.sub_disposal_vendor_name)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">事業者名</label>
                    <b-form-input type="text" maxlength="260" v-model="manifest.sub_disposal_vendor_name" :disabled="isEdited('sub_disposal_vendor_name')"/>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="6">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_end_date, manifestForDiff.sub_disposal_vendor_end_date)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">処分終了日</label>
                    <date-picker
                      v-model="manifest.sub_disposal_vendor_end_date"
                      :disabled="isEdited('sub_disposal_vendor_end_date')"
                      lang="ja"
                      placeholder="YYYY-MM-DD"
                      format="YYYY-MM-DD"
                      value-type="format"
                      type="date"
                    ></date-picker>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_delivery_car_number, manifestForDiff.sub_disposal_vendor_delivery_car_number)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">車両番号</label>
                    <b-form-input type="text" maxlength="30" v-model="manifest.sub_disposal_vendor_delivery_car_number"
                                  :disabled="isEdited('sub_disposal_vendor_delivery_car_number')"/>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="6">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_waste_reception_date, manifestForDiff.sub_disposal_vendor_waste_reception_date)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">廃棄物の受領日</label>
                    <date-picker
                      v-model="manifest.sub_disposal_vendor_waste_reception_date"
                      :disabled="isEdited('sub_disposal_vendor_waste_reception_date')"
                      lang="ja"
                      placeholder="YYYY-MM-DD"
                      format="YYYY-MM-DD"
                      value-type="format"
                      type="date"
                    ></date-picker>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="6">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_disposal_amount, manifestForDiff.sub_disposal_vendor_disposal_amount)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">受入量</label>
                    <b-form-input type="number" maxlength="8" v-model="manifest.sub_disposal_vendor_disposal_amount"
                                  :disabled="isEdited('sub_disposal_vendor_disposal_amount')"/>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_disposal_unit, manifestForDiff.sub_disposal_vendor_disposal_unit)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">受入量単位</label>
                    <b-form-select class="form-select" v-model="manifest.sub_disposal_vendor_disposal_unit" :options="zzJwUnits" :disabled="isEdited('sub_disposal_vendor_disposal_unit')"/>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="6">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_delivery_person_in_charge, manifestForDiff.sub_disposal_vendor_delivery_person_in_charge)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">運搬担当者</label>
                    <b-form-input type="text" maxlength="24" v-model="manifest.sub_disposal_vendor_delivery_person_in_charge"
                                  :disabled="isEdited('sub_disposal_vendor_delivery_person_in_charge')"/>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="6">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_reporting_user_name, manifestForDiff.sub_disposal_vendor_reporting_user_name)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">報告担当者</label>
                    <b-form-input type="text" maxlength="24" v-model="manifest.sub_disposal_vendor_reporting_user_name"
                                  :disabled="isEdited('sub_disposal_vendor_reporting_user_name')"/>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_treatment_person_in_charge, manifestForDiff.sub_disposal_vendor_treatment_person_in_charge)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">処分担当者</label>
                    <b-form-input type="text" maxlength="24" v-model="manifest.sub_disposal_vendor_treatment_person_in_charge"
                                  :disabled="isEdited('sub_disposal_vendor_treatment_person_in_charge')"/>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="12">
                  <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_remarks, manifestForDiff.sub_disposal_vendor_remarks)
                    && manifest.manifest_type_cd != 1}">
                    <label for="">備考</label>
                    <b-form-input type="text" maxlength="256" v-model="manifest.sub_disposal_vendor_remarks" :disabled="isEdited('sub_disposal_vendor_remarks')"/>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="12">
                  <div class="custom-radio-group gap-2" :class="{'bg-warning':isDiff(manifest.sub_disposal_vendor_valuables, manifestForDiff.sub_disposal_vendor_valuables)
                    && manifest.manifest_type_cd != 1}">
                    <label class="label-group">有価物</label>
                    <b-form-radio-group
                      class="d-flex align-items-center gap-2 w-100 h-100"
                      v-model="manifest.sub_disposal_vendor_valuables"
                      :disabled="isEdited('sub_disposal_vendor_valuables')"
                      text-field="valuables_involved_type"
                      value-field="id"
                      :options="zzValuablesInvolvedTypes()"
                    ></b-form-radio-group>
                  </div>
                </b-col>
              </b-row>


            </div>
          </div>
          <div>
            <div :class="(isEdit ? 'bg-info ' : 'bg-success ') + 'ps-1 title mt-3 fw-bold font-size-16 text-white'" ref="final_disposal_site">
              最終処分場
            </div>
            <!-- 親要素としてそのマニフェストの処理後廃棄物で回す -->
            <!-- JWNは処理後廃棄物という概念はない。最終処分場の情報だけ持っているのでマニフェストと同じ処理はできない。 -->
            <!-- ので、isEditの場合はこちらの処理をする -->
            <div
              v-if="manifest.wastes_after_treatment_by_manifest && isEdit"
              v-for="(item,index) in manifest['wastes_after_treatment_by_manifest']"
              :key="index">
              <b-card>
              <b-row class="mt-2">
                <b-col cols="6">
                  <div class="custom-input gap-2">
                    <label for="">処理後廃棄物種類</label>
                    <b-form-select v-model="item.waste_category_id" class="form-select"
                                  :disabled="isEdited('sub_disposal_waste_category_id')"
                                  :options="setDefaultWasteAfterTreatment"
                                  />
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="custom-input gap-2">
                    <label for="">二次ﾏﾆﾌｪｽﾄ番号</label>
                    <b-form-input 
                      type="text" maxlength="11" v-model="item.issue_number_2nd"
                      :disabled="isEdited('sub_disposal_issue_number_2nd')"
                      />
                  </div>
                </b-col>
              </b-row>
              <!-- この処理後廃棄物に対していくつ最終処分先があるかで回す -->
              <div v-if="item.final_disposal_site_by_manifest"
                  v-for="(item_fdsbm,index_fdsmb) in item['final_disposal_site_by_manifest']"
                  :key="index_fdsmb" class="ms-2 mt-2 custom-h-final"

                  >
                <div class="bg-info ps-1 title  fw-bold font-size-16 text-white">
                  最終処分場 {{ index_fdsmb + 1 }}
                </div>

                <b-row class="mt-2">
                  <b-col cols="6">
                    <div class="custom-input gap-2">
                      <label for="">最終処分終了日</label>
                      <date-picker
                        v-model="item_fdsbm.final_disposal_site_treatment_end_date"
                        :disabled="isEdited('final_disposal_site_treatment_end_date')"
                        lang="ja"
                        placeholder="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        value-type="format"
                        type="date"
                      ></date-picker>

                    </div>
                  </b-col>
                  <b-col cols="6">
                    <div class="custom-input gap-2">
                      <label for="">処分場所</label>
                      <b-form-input type="text" maxlength="130" v-model="item_fdsbm.final_disposal_site_name" :disabled="isEdited('final_disposal_site_name')"/>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col cols="6">
                      <div class="custom-input gap-2">
                        <label for="">電話番号</label>
                        <b-form-input type="text" maxlength="15" v-model="item_fdsbm.final_disposal_site_tel" :disabled="isEdited('final_disposal_site_tel')"/>
                      </div>
                    </b-col>
                  <b-col cols="6">
                    <div class="custom-input gap-2">
                      <label for="">郵便番号</label>
                      <b-form-input type="text" maxlength="8" v-model="item_fdsbm.final_disposal_site_zip" :disabled="isEdited('final_disposal_site_zip')"/>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col cols="6">
                    <div class="custom-input gap-2">
                      <label for="">都道府県</label>
                      <b-form-input type="text" maxlength="8" v-model="item_fdsbm.final_disposal_site_address_1" :disabled="isEdited('final_disposal_site_address_1')"/>
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <div class="custom-input gap-2">
                      <label for="">市区</label>
                      <b-form-input type="text" maxlength="40" v-model="item_fdsbm.final_disposal_site_address_2" :disabled="isEdited('final_disposal_site_address_2')"/>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col cols="6">
                    <div class="custom-input gap-2">
                      <label for="">町村</label>
                      <b-form-input type="text" maxlength="80" v-model="item_fdsbm.final_disposal_site_address_3" :disabled="isEdited('final_disposal_site_address_3')"/>
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <div class="custom-input gap-2">
                      <label for="">番地建物名</label>
                      <b-form-input type="text" maxlength="100" v-model="item_fdsbm.final_disposal_site_address_4" :disabled="isEdited('final_disposal_site_address_4')"/>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-row class="mtop4" v-if="checkInputFinalDiposal()">
                <b-col cols="6">
                  <button
                  class="btn btn-primary mr-1"
                  v-if="isEdit" 
                  @click="addFinalDisposalSite(item)"
                >
                  <i class="fas fa-plus-square"></i>
                  最終処分場追加
                </button>
                </b-col>
                <b-col cols="6">
                  <button
                  class="btn btn-primary mr-1"
                  v-if="isEdit && showRemoveFinalDisposalSite(item)"
                  @click="removeFinalDisposalSite(item)"
                >
                <i class="fas fa-minus-square"></i>
                最終処分場削除
                </button>
                </b-col>
              </b-row>
              </b-card>
            </div>
              <b-row class="mtop4" v-if="checkInputFinalDiposal()">
              <b-col cols="6">
                <button
                class="btn btn-primary mr-1"
                v-if="isEdit" 
                @click="addWasteCategoryAfterTreatment()"
              >
                <i class="fas fa-plus-square"></i>
                処理後廃棄物追加
              </button>
              </b-col>
              <b-col cols="6">
                <button
                class="btn btn-primary mr-1"
                v-if="isEdit && showRemoveWasteCategoryAfterTreatment()"
                @click="removeWasteCategoryAfterTreatment(item)"
              >
              <i class="fas fa-minus-square"></i>
              処理後廃棄物削除
              </button>
              </b-col>
            </b-row>

            <!-- JWN側の場合、処理後廃棄物という概念はないのでその分のループは組まない。 -->
            <!--
            <div
              v-if="manifest.wastes_after_treatment_by_manifest && isEdit"
              v-for="(item,index) in manifest[wastes_after_treatment_by_manifest]"
              :key="index">
              <b-row class="mt-2">
                <b-col cols="6">
                  <div class="custom-input gap-2">
                    <label for="">処理後廃棄物種類</label>
                    <b-form-select v-model="item.waste_category_id" class="form-select"
                                  :disabled="isEdited('sub_disposal_waste_category_id')"
                                  :options="subDisposalWasteCategory(item)"
                                  />
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="custom-input gap-2">
                    <label for="">二次ﾏﾆﾌｪｽﾄ番号</label>
                    <b-form-input 
                      type="text" maxlength="11" v-model="item.issue_number_2nd"
                      :disabled="isEdited('sub_disposal_issue_number_2nd')"
                      />
                  </div>
                </b-col>
              </b-row>
            -->
              <!-- このJWNマニフェストに対していくつ最終処分先があるかで回す -->
              <div v-if="manifest.final_disposal_site_by_jwn_manifest && !isEdit"
                  v-for="(item_fdsbm,index_fdsmb) in manifest['final_disposal_site_by_jwn_manifest']"
                  :key="index_fdsmb" class="ms-2 mt-2 custom-h-final">
                <div class="bg-success ps-1 title  fw-bold font-size-16 text-white">
                  最終処分場 {{ index_fdsmb + 1 }}
                </div>
                
                <section :class="checkDifferFDS(item_fdsbm)">
                  <b-row class="mt-2">
                    <b-col cols="6">
                      <div class="custom-input gap-2">
                        <label for="">最終処分終了日</label>
                        <date-picker
                          v-model="item_fdsbm.final_disposal_site_treatment_end_date"
                          :disabled="isEdited('final_disposal_site_treatment_end_date')"
                          lang="ja"
                          placeholder="YYYY-MM-DD"
                          format="YYYY-MM-DD"
                          value-type="format"
                          type="date"
                        ></date-picker>

                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="custom-input gap-2">
                        <label for="">処分場所</label>
                        <b-form-input type="text" maxlength="130" v-model="item_fdsbm.final_disposal_site_name" :disabled="isEdited('final_disposal_site_name')"/>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="6">
                      <div class="custom-input gap-2">
                        <label for="">電話番号</label>
                        <b-form-input type="text" maxlength="15" v-model="item_fdsbm.final_disposal_site_tel" :disabled="isEdited('final_disposal_site_tel')"/>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="custom-input gap-2">
                        <label for="">郵便番号</label>
                        <b-form-input type="text" maxlength="8" v-model="item_fdsbm.final_disposal_site_zip" :disabled="isEdited('final_disposal_site_zip')"/>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="6">
                      <div class="custom-input gap-2">
                        <label for="">都道府県</label>
                        <b-form-input type="text" maxlength="8" v-model="item_fdsbm.final_disposal_site_address_1" :disabled="isEdited('final_disposal_site_address_1')"/>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="custom-input gap-2">
                        <label for="">市区</label>
                        <b-form-input type="text" maxlength="40" v-model="item_fdsbm.final_disposal_site_address_2" :disabled="isEdited('final_disposal_site_address_2')"/>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="6">
                      <div class="custom-input gap-2">
                        <label for="">町村</label>
                        <b-form-input type="text" maxlength="80" v-model="item_fdsbm.final_disposal_site_address_3" :disabled="isEdited('final_disposal_site_address_3')"/>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="custom-input gap-2">
                        <label for="">番地建物名</label>
                        <b-form-input type="text" maxlength="100" v-model="item_fdsbm.final_disposal_site_address_4" :disabled="isEdited('final_disposal_site_address_4')"/>
                      </div>
                    </b-col>
                  </b-row>
                </section>
              </div>
            <!-- </div> -->
          </div>

          <div class="ms-2" :style="marginBoxFinal ? 'margin-top:' + marginBoxFinal + 'px' : ''">
            <div :class="(isEdit ? 'bg-info ' : 'bg-success ') + 'ps-1 title mt-3 fw-bold font-size-16 text-white'"> 運搬の受託（積込）</div>
            <b-row class="mt-2" >
              <b-col cols="12">
                <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_transport_and_hold_vendor_name, manifestForDiff.sub_transport_and_hold_vendor_name)
                  && manifest.manifest_type_cd != 1}">
                  <label for="">事業者名</label>
                  <b-form-input type="text" maxlength="260"  v-model="manifest.sub_transport_and_hold_vendor_name" :disabled="isEdited('sub_transport_and_hold_vendor_name')"/>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2" >
              <b-col cols="12">
                <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_transport_and_hold_vendor_reporting_user_name, manifestForDiff.sub_transport_and_hold_vendor_reporting_user_name)
                  && manifest.manifest_type_cd != 1}">
                  <label for="" >担当者名</label>
                  <b-form-input type="text"  maxlength="24" v-model="manifest.sub_transport_and_hold_vendor_reporting_user_name" :disabled="isEdited('sub_transport_and_hold_vendor_reporting_user_name')"/>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2" >
              <b-col cols="12">
                <div class="custom-input gap-2" :class="{'bg-warning':isDiff(manifest.sub_transport_and_hold_vendor_end_date, manifestForDiff.sub_transport_and_hold_vendor_end_date)
                  && manifest.manifest_type_cd != 1}">
                  <label for="" >積替保管排出日</label>
                  <date-picker
                    v-model="manifest.sub_transport_and_hold_vendor_end_date"
                    :disabled="isEdited('sub_transport_and_hold_vendor_end_date')"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="format"
                    type="date"
                  ></date-picker>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ml-custom {
  margin-left: 105px;
}

.icon {
  float: right;
  transition: transform 0.3s;
}

.rotate {
  transform: rotate(-90deg);
}

.box-waste-custom {
  min-height: 125px;
}

.box-waste1-custom {
  min-height: 150px;
}

ul {
  margin: 0;
}
.custom-minH{
  min-height: 21px;
}
.custom-lbl-box{
  flex: none;
  width: 100px;
}
.custom-h-final{
  min-height: 305px;
}
.custom-jw{
  background-color: white;
}
.mtop4{
  margin-top: 4px;
}
</style>
